import "./style/style.scss";
import App from "./Components/App.svelte";

new App({
    target: document.body,
});

export {};
